import UploadFileWithSteps from "components/UploadFileWithSteps/UploadFileWithSteps";

const UploadFileBlock = ({
    form,
    changeForm, 
    errors,
    title,
    description
}) => {
    const changeFileData = (newFile) => {
        changeForm({ ...newFile });
    }
    return (
        <UploadFileWithSteps 
            description={description}
            title={title}
            annotation="Te recomendamos que no subas un archivos con más de 1000 registros"
            file={form.fileData}
            error={errors.fileData}
            errorText="Es necesario que descargues y subas el archivo modificado con los errores para poder guardar y finalizar."
            onChange={changeFileData}
            formatFile="/Documents/RefuerzoAcademico/Carga_masiva/refuerzo_formato_registros_carga_masiva.xlsx"/>
    );
}

export default UploadFileBlock;